if (!window.Eurus.loadedScript.has('product-review-scroll.js')) {
  window.Eurus.loadedScript.add('product-review-scroll.js');

  (() => {
    const triggerSelector = '.section-product-info .product-info .x-review-product.okendo';
    const targetSelectors = [
      '[data-okendo-reviews-widget]',
      '[data-oke-reviews-widget]',
      '[data-oke-widget]',
      'div[id^="shopify-block-okendo_reviews"]',
      'div[id*="okendo"][id*="reviews"]',
      '.okeReviews',
      '.oke-w',
      'div[id^="shopify-block-okendo"]'
    ];

    const isVisible = (element) => {
      if (!element || element.closest(triggerSelector)) return false;
      const styles = window.getComputedStyle(element);

      return !element.hidden
        && styles.display !== 'none'
        && styles.visibility !== 'hidden'
        && element.getClientRects().length > 0;
    };

    const getReviewsTarget = () => {
      for (const selector of targetSelectors) {
        const element = Array.from(document.querySelectorAll(selector)).find(isVisible);
        if (element) return element.closest('.shopify-section') || element;
      }

      return null;
    };

    const getHeaderOffset = () => {
      const headerStore = window.Alpine?.store?.('xHeaderMenu');
      const storeOffset = headerStore
        ? Math.max(
          headerStore.announcementOffsetHeight || 0,
          (headerStore.announcementOffsetHeight || 0) + (headerStore.stickyOffsetHeight || 0) - (headerStore.toolbarOffsetHeight || 0)
        )
        : 0;
      const cssOffset = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--height-header')) || 0;
      const fixedHeader = Array.from(document.querySelectorAll('#shopify-section-header, .shopify-section-header-sticky, sticky-header'))
        .find((element) => {
          const styles = window.getComputedStyle(element);
          return ['fixed', 'sticky'].includes(styles.position) && isVisible(element);
        });
      const elementOffset = fixedHeader ? fixedHeader.getBoundingClientRect().height : 0;

      return Math.max(storeOffset, cssOffset, elementOffset) + 16;
    };

    const scrollToReviews = (attempt = 0) => {
      const target = getReviewsTarget();

      if (!target) {
        if (attempt < 20) {
          window.setTimeout(() => scrollToReviews(attempt + 1), 100);
        }
        return;
      }

      const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
      window.scrollTo({
        top: Math.max(top, 0),
        behavior: 'smooth'
      });
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(triggerSelector);
      if (!trigger) return;

      event.preventDefault();
      scrollToReviews();
    });
  })();
}
